import { Upload, X } from "lucide-react";
import CustomSelect from "../../shared/CustomSelect";
import { useRef, useState } from "react";
import { uploadMultiImages } from "../../sdk/upload/upload";
import Loading from "../../shared/Loading";

const AddPayslips = ({
  closeAddPayslips,
  handleNextStep,
  setPayslips,
  loading,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    try {
      const uploadedUrls = await uploadMultiImages(files);
      setPayslips(uploadedUrls);
    } catch (err) {
      console.error("Failed to upload files:", err);
    }
    setSelectedFiles(files);
  };

  const handleChooseFileClick = () => {
    fileInputRef.current?.click();
  };
  return (
    <div
      onClick={(e) => {
        closeAddPayslips();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddPayslips}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] w-full px-[20px] left-0 flex items-center gap-[10px] justify-end">
          <button
            onClick={closeAddPayslips}
            className="bg-[#F3F3F3] h-[35px] px-[20px] rounded-[30px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Close
          </button>
          <button
            onClick={handleNextStep}
            disabled={loading}
            className="h-[35px] bg-[#000000] rounded-[30px] flex items-center justify-center gap-[5px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Add Payslips
          </button>
        </div>
        <p className="text-[#000000] font-normal text-[14px]">
          Edit Loan Application
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">
          Borrower’s Income Details
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal">
          Upload latest payslips
        </p>
        <div className="flex items-start gap-[20px] my-[10px]">
          <div className="flex w-[100%] flex-col">
            <label
              className="text-[#222222] font-medium text-[12px] truncate"
              htmlFor="Payslip Type"
            >
              Payslip Type
            </label>
            <CustomSelect
              name="Payslip Type"
              onChange={(e) => {}}
              options={["3 months", "6 months"]}
            />
          </div>
        </div>
        <div className="flex w-[100%] my-[20px] flex-col">
          <p className="text-[#222222] font-medium text-[13px]">
            Payslips{" "}
            <span className="font-normal text-[#5C5C5C]">
              .jpeg or .png file only
            </span>
          </p>
          <div
            className="min-h-[90px] px-[10px] py-[12px] flex flex-col gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer"
            onClick={handleChooseFileClick}
          >
            {selectedFiles.length > 0 ? (
              <div className="flex flex-wrap gap-[10px]">
                {selectedFiles.map((file, index) => (
                  <div
                    key={index}
                    className="min-w-[120px] px-[8px] py-[6px] rounded-[6px] bg-[#F9F9F9] border border-[#DDD] text-center"
                  >
                    <p className="text-[12px] font-semibold text-black truncate">
                      {file.name}
                    </p>
                    <p className="text-[11px] text-gray-500">
                      {(file.size / 1024).toFixed(2)} KB
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <>
                <Upload />
                <p className="text-[#000000] text-[12px] font-normal">
                  Drag and Drop file here or{" "}
                  <span className="text-[#000000] underline">Choose file</span>{" "}
                  here
                </p>
              </>
            )}
            <input
              type="file"
              multiple
              ref={fileInputRef}
              className="hidden"
              onChange={handleFileChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPayslips;
